import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import RoleBasedLayout from './RoleBasedLayout';

/**
 * Parent shell layout.
 * Uses RoleBasedLayout navigation (parent menu items) rather than teacher shell.
 */
export default function ParentLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (!isMobile) setOpen(false);
  }, [isMobile]);

  return (
    <RoleBasedLayout
      open={open}
      onClose={() => setOpen(false)}
      collapsed={collapsed}
      onToggleCollapse={() => setCollapsed((v) => !v)}
    >
      {children}
    </RoleBasedLayout>
  );
}

